import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { actions as axisOrderActions } from '../actions/axisOrder';
import { Container, MainContent, StickyFooter } from '../styled-components/Layout';
import LoadingIndicator from '../components/LoadingIndicator';
import AttachedFileButton from '../components/OrderForm/AttachedFileButton';
import AttachedFilesList from '../components/OrderForm/AttachedFilesList';
import EditItem from '../components/OrderForm/EditItem';
import Footer from '../components/OrderForm/Footer';
import ItemList from '../components/OrderForm/ItemList';
import OrderDetails from '../components/OrderForm/OrderDetails';
import MediaReplaceableSidebar from '../components/Editor/MediaReplaceableSidebar';

const ItemPlaceholder = styled.div`
  border: 1px solid rgb(207, 205, 205);
  margin: 0.5rem 0;
  visibility: ${props => (props.children ? 'visible' : 'hidden')};
`;

const OrderContainer = styled(Container) `
  background-color: #ECECEC;
  height: 100%;
  flex-direction: row;
`;

const OrderContent = styled(MainContent) `
  padding: .25rem;
  display: flex;
  flex-direction: column;
`;

const OrderContentContainer = styled(Container)`
  width: 100%;
`;

const MediaReplaceablesContainer = styled(Container)`
  padding: 1rem;
  height: 100%;
  width: 10rem;
  border-left: 1px solid grey;
`;

class OrderGraphicLayout extends Component {
  handleOnSubmitButtonClicked() {
    if (this.props.isValid) {
      this.props.onSubmit();
    } else {
      this.props.onValidate();
    }
  }
  renderItemPlaceholder() {
    if (this.props.showEditItemView) {
      return <EditItem highlightErrors={this.props.isValidating} />;
    }

    return null;
  }
  render() {
    return (
      <OrderContainer>
        <LoadingIndicator visible={this.props.isLoading} />
        <OrderContentContainer>
          <OrderContent>
            <OrderDetails highlightErrors={this.props.isValidating} />
            <ItemList />
            <ItemPlaceholder>
              {this.renderItemPlaceholder()}
            </ItemPlaceholder>
            <AttachedFileButton />
            <AttachedFilesList />
            <Footer onSubmit={this.handleOnSubmitButtonClicked.bind(this)} />
          </OrderContent>
          <StickyFooter />
        </OrderContentContainer>
        <MediaReplaceablesContainer>
          <MediaReplaceableSidebar />
        </MediaReplaceablesContainer>
      </OrderContainer>
    );
  }
}

OrderGraphicLayout.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  isValidating: PropTypes.bool.isRequired,
  showEditItemView: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  isLoading: !state.axisOrder.projects || state.axisOrder.projects.length < 1,
  isValid: state.axisOrder.hiddenMessage === '',
  isValidating: state.axisOrder.isValidating,
  showEditItemView: !!state.axisOrder.currentItem.replaceableId
});

const mapDispatchToProps = {
  onSubmit: axisOrderActions.submitOrder,
  onValidate: axisOrderActions.validateOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderGraphicLayout);



// WEBPACK FOOTER //
// ./app/layouts/OrderGraphicLayout.js